
import { defineComponent } from 'vue';
import AdImage from './AdImage.vue';
import { adService } from '../AdService';

export default defineComponent({
  name: 'AdListGallery',
  components: {
    AdImage,
  },
  props: {
    adGuid: String,
    estateType: {
      required: true,
      type: Number,
    },
    estateSubType: {
      required: true,
      type: Number,
    },
    images: Array,
    width: {
      type: Number,
      default: 610,
    },
    height: {
      type: Number,
      default: 440,
    },
    imageLimitCount: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      currentPage: 1,
      showPhotoCounter: false,
      showCounterTimeout: null as any,
    };
  },
  computed: {
    pageCount(): number {
      //return Math.ceil(this.images.length / this.imageLimitCount);
      return this.images ? this.images.length : 0;
    },
    photoCounter(): number {
      //const count = this.currentPage * this.imageLimitCount;
      //if (count > this.images.length) return this.images.length;
      //return count;
      return this.currentPage;
    },
    thumbs(): any[] {
      if (!this.images || this.images.length === 0) {
        return new Array(this.imageLimitCount);
      } else if (this.images.length < this.imageLimitCount) {
        const result = this.images.slice(0);
        for (let i = this.images.length; i < this.imageLimitCount; i++) {
          result.push(null);
        }
        return result;
      } else {
        //const start = this.currentPage * this.imageLimitCount - this.imageLimitCount;
        //const end = start + this.imageLimitCount;
        const start = this.currentPage - 1;
        const end = start + this.imageLimitCount;
        const result = this.images.slice(start, end);
        if (result.length < this.imageLimitCount) {
          result.push(...this.images.slice(0, this.imageLimitCount - result.length));
        }
        return result;
      }
    },
  },
  methods: {
    onPrevious() {
      if (this.currentPage === 1) {
        this.currentPage = this.pageCount;
      } else {
        this.currentPage--;
      }
      this.showCounter();
      adService.view(this.adGuid);
    },
    onNext() {
      if (this.currentPage === this.pageCount) {
        this.currentPage = 1;
      } else {
        this.currentPage++;
      }
      this.showCounter();
      adService.view(this.adGuid);
    },
    showCounter() {
      if (this.showCounterTimeout) {
        clearTimeout(this.showCounterTimeout);
      }
      this.showPhotoCounter = true;
      this.showCounterTimeout = setTimeout(() => (this.showPhotoCounter = false), 3000);
    },
  },
});
